import StyledField from 'common/TextField/TexField1';
import { Button, FormControlLabel, Grid, Switch } from '@mui/material';
import Filter from "common/Select/SelectMultiFilter";
import { useTranslation } from 'react-i18next';
import DynamicSelect from 'common/Select/Select';
import { themes } from 'theme/themes';
import { brandingInfo } from 'features/server/brandingSlice';
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import DateRangePicker from 'common/Pickers/DateRangePicker';

interface SalesCreditNotesSearchHeaderComponentProps {
  handleChangeFilter: (event: any) => void;
  handleChangeSearch: (field: string, value: any) => void;
  handleSubmitSearch: () => void;
  searchFormData: any;
  // searchErrorMessages:{ [key: string]: string };
  filter: string[];
  clearSearch: () => void;
  search: any;
  stationData: any;
  handleDropdownActions: (typeName: string, action: 'searchIt' | 'loadNext', search?: string) => void;
  dropdownPage: number; 
  searchLoading: string | null; 
  dropdownSearchTerm: any; 
  setDropdownSearchTerm: any;
  setDropdownPage: any;
  stationResponse: any;
}

const SalesCreditNotesSearchHeader: React.FC<SalesCreditNotesSearchHeaderComponentProps> = ({
  handleChangeFilter,
  handleChangeSearch,
  handleSubmitSearch,
  searchFormData,
  // searchErrorMessages,
  filter,
  clearSearch,
  search,
  stationData,
  stationResponse,
  handleDropdownActions,
  dropdownPage, searchLoading, dropdownSearchTerm, setDropdownSearchTerm, setDropdownPage
}) => {
  const stationOptions = stationData.map((item: { id: number, name: string }) => ({
    value: item.id, 
    label: item.name
  }));
  const { t } = useTranslation();
  const branding = useSelector(brandingInfo);
  const themeColors = branding?.attributes?.themeId === 100 ? branding?.attributes?.customTheme : (themes as any)[branding?.attributes?.themeId || 3];
  const filterOptions = ['creditNoteNo', 'vehiclePlate', 'vehicleVin', 'clientName', 'stationId', 'dateInterval'];
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      handleSubmitSearch();
    }
  };
  
  return (
    <>
      <Grid container spacing={1} alignItems="flex-start">
        <Grid item xs={12} sm={6} md={3} lg={2}>
          <Filter 
            label="Filter By"
            filterOptions={filterOptions}
            handleChangeFilter={handleChangeFilter}
            filter={filter}
          />
        </Grid>
        {filter.map((fieldName) => (
          <>
            {fieldName === 'dateInterval' ? <Grid item key={fieldName} xs={12} sm={6} md={3}>
                <DateRangePicker
                  label=''
                  maxDate={dayjs()}
                  placeholder={'YYYY-MM-DD → YYYY-MM-DD'}
                  onChange={(value) =>
                    handleChangeSearch('dateInterval', [value?.[0] ? value[0].format('YYYY-MM-DD') : null, value?.[1] ? value[1].format('YYYY-MM-DD') : null,])
                  }
                  value={[
                    searchFormData?.start ? dayjs(searchFormData.start) : null,
                    searchFormData?.end ? dayjs(searchFormData.end) : null,
                  ]}
                />
              </Grid>
              : fieldName === 'stationId' ? 
              <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                <DynamicSelect
                  value={searchFormData?.stationId ? { value: searchFormData?.stationId, label: searchFormData?.stationName || searchFormData?.stationId } : null}
                  isDisabled={false}
                  isClearable={true}
                  isRtl={false}
                  // fullWidth={false}
                  isSearchable={true}
                  name="stationId"
                  options={stationOptions}
                  // onScroll={handleScroll}
                  // onInputChange={handleSearch}
                  // isMulti
                  isRequired={true}
                  onChange={(e) => handleChangeSearch('stationId', e)}
                  // error={searchErrorMessages?.stationId}
                  label=""
                  onKeyDown={handleKeyPress}
                  defaultPlaceholder={t('station')}
                  isLoading={searchLoading === 'stations'}
                  onInputChange={(search: string, { action }: { action: string }) => {
                    if(action === 'input-change' || 
                      (action !== 'set-value' && action !== 'menu-close' && action !== 'input-blur')
                    ) handleDropdownActions("stations", 'searchIt', search);
                    else if(action === 'input-blur' || action === 'menu-close') {
                      if(dropdownSearchTerm || dropdownPage > 1) handleDropdownActions("stations", 'searchIt', '');
                      else setDropdownSearchTerm('');
                      setDropdownPage(1);
                    }
                  }}
                  onMenuScrollToBottom={() => {if(!(stationResponse?.pages[0]?.data as any).last) handleDropdownActions("stations", 'loadNext')}}
                  page={dropdownPage}
                />
              </Grid> 
              : fieldName === 'isActive' ? 
              <Grid item key={fieldName}>
                <FormControlLabel 
                  control={
                    <Switch 
                      onChange={(e) => handleChangeSearch(fieldName, e.target.checked)}
                      checked={searchFormData.isActive} 
                      sx={{
                        '& .MuiSwitch-switchBase.Mui-checked': {
                          color: themeColors?.primary,
                        },
                        '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
                          backgroundColor: themeColors?.primary,
                        },
                        transform: 'scale(1.3)'
                      }}
                    />
                  } 
                  label={<span className='text-[12px] font-bold font-Saira'>{t('hideClosed')}</span>}
                  sx={{ flexDirection: 'row-reverse', padding: '0 0 0 20px' }}
                />
              </Grid>
              : <Grid item key={fieldName} xs={12} sm={6} md={3} lg={2}>
                  <StyledField
                    fullWidth={true}
                    placeholder={t(fieldName)}
                    displayPlaceholder={true}
                    handleChange={(e) => handleChangeSearch(fieldName, e.target.value)}
                    required={true}
                    // error={searchErrorMessages[fieldName]}
                    value={searchFormData?.[fieldName] || ''}
                    handleKeyDown={handleKeyPress}
                  />
              </Grid>
            }
          </>
        ))}
        <Grid item xs={12} sm={6} md={2} sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
          <Button 
            variant="contained"
            disabled={filter.length ? false : true}
            onClick={handleSubmitSearch}
            sx={{
              boxShadow: 'none',
              background: filter.length > 0 ? themeColors?.primary : '#B8C0C6',
              height: 38,
              minHeight: 38,
            }}
            className={`text-white text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] px-8 py-1`}
          >{t('submit')}</Button>
          {filter.length && Object.keys(search).length || filter.length > 1 ?
            <Button 
            variant="contained"
            onClick={clearSearch}
            sx={{
              boxShadow: 'none',
              color: themeColors?.primary,
              height: 38,
              minHeight: 38,
            }}
            className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] bg-[#d8d1e0] px-8 py-1`}
          >{t('clear')}</Button>: null}
          {/* {filter.length && Object.keys(search).length || filter.length > 1 ?
            <span 
              className={`font-Saira font-[600] text-[14px] leading-[19px] text-selectedborder-color ms-[10px] cursor-pointer underline`}
              onClick={clearSearch}
            >
              {t('Clear')}
            </span> : null
          } */}
        </Grid>
      </Grid>
    </>
  );
};

export default SalesCreditNotesSearchHeader;